export default __webpack_public_path__ + "static/media/heighMeasurement.8116fd7a.jpeg";